export default "__VITE_ASSET__C_b242jJ__"